import { GroupRoutineType } from '../types/grouproutines.type';
import { HTTPServices } from './base.service';

export class WarmupsServices extends HTTPServices {
    private static BASE_ROUTE = 'warmups/';

    static getAll() {
        return WarmupsServices.get<GroupRoutineType[]>(WarmupsServices.BASE_ROUTE);
    }

    static add(data: GroupRoutineType) {
        return WarmupsServices.post<GroupRoutineType>(WarmupsServices.BASE_ROUTE, data);
    }
    static update(id: number, data: GroupRoutineType) {
        return WarmupsServices.put<GroupRoutineType>(WarmupsServices.BASE_ROUTE + id, data);
    }

    static getById(id: number) {
        return WarmupsServices.get<GroupRoutineType>(WarmupsServices.BASE_ROUTE + id);
    }

    static deleteById(id: number) {
        return WarmupsServices.delete<GroupRoutineType[]>(WarmupsServices.BASE_ROUTE + id);
    }
}
